/* fk-product.js — product page behaviour (sections/fk-main-product.liquid renders the markup).
   Port of the mockup's page script: gallery, size -> button label (typewriter), Shop Pay reveal, sticky bar,
   size guide follows the pick, "Complete the fit" carousel. Runs after fk-shop.js (DOMContentLoaded). */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-fk-pdp]');
  if (!root || !window.FK) return;
  var $ = FK.$, $$ = FK.$$, esc = FK.esc;
  var handle = root.getAttribute('data-handle'), one = root.hasAttribute('data-one-size');

  /* ---- gallery: swipe / trackpad / arrows; Pythia's segmented bar ---- */
  var track = $('[data-fk-slides]', root), segs = $$('[data-fk-bar] i', root), prev = $('[data-fk-prev]', root), next = $('[data-fk-next]', root);
  var count = $$('.fk-slider__slide', track).length;
  function syncGal() { var i = Math.round(track.scrollLeft / track.clientWidth); segs.forEach(function (s, n) { s.classList.toggle('is-on', n === i); }); prev.disabled = i === 0; next.disabled = i >= count - 1; }
  track.addEventListener('scroll', function () { requestAnimationFrame(syncGal); }, { passive: true });
  prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
  document.addEventListener('keydown', function (e) { if (e.target.closest('input,textarea,select')) return; if (e.key === 'ArrowRight') next.click(); if (e.key === 'ArrowLeft') prev.click(); });
  syncGal();

  /* ---- Complete the fit carousel (cards are server-rendered; the shared [data-fk-add] handler adds them) ---- */
  var row = $('[data-fk-ctf-row]', root);
  if (row) {
    var cPrev = $('[data-fk-ctf-prev]', root), cNext = $('[data-fk-ctf-next]', root);
    var syncCtf = function () { cPrev.disabled = row.scrollLeft < 4; cNext.disabled = row.scrollLeft + row.clientWidth > row.scrollWidth - 4; };
    var stepCtf = function (d) { var c = row.querySelector('li'); row.scrollBy({ left: d * (c.getBoundingClientRect().width + 12), behavior: 'smooth' }); };
    cPrev.addEventListener('click', function () { stepCtf(-1); }); cNext.addEventListener('click', function () { stepCtf(1); });
    row.addEventListener('scroll', function () { requestAnimationFrame(syncCtf); }, { passive: true });
    syncCtf();
  }

  // also find the form by its action, so a missing data attribute can never fall back to a plain /cart submit
  var form = $('[data-fk-buy]', root) || $('form[action*="/cart/add"]', root), atc = $('[data-fk-atc]', root);
  if (!form || !atc || atc.disabled) return;   // sold out: nothing to buy, no sticky bar

  /* ---- size -> button label (typewriter), Shop Pay appears, sticky bar follows ---- */
  var label = $('[data-fk-atc-label]', root), stickyLabel = $('[data-fk-sticky-label]'), sizes = $('[data-fk-sizes]', root), busy = false;
  var remind = $('.fk-buy [data-fk-remind]', root), shoppay = $('[data-fk-shoppay]', root);
  // a sold-out size stays pickable (crossed out); picking it swaps Add to cart for "Remind me when this drops"
  function isOut() { var r = $('input[name="fk-size"]:checked', form); return !!(r && r.hasAttribute('data-out')); }
  // the form's single name="id" field: Shopify's express checkout buttons read it, so it must always be the picked size
  var variantField = $('[data-fk-variant-id]', form);
  function syncVariant() {
    var r = $('input[name="fk-size"]:checked', form);
    if (!r || !variantField || variantField.value === r.value) return;
    variantField.value = r.value;
    variantField.dispatchEvent(new Event('change', { bubbles: true }));
  }
  var priceHTML = $('[data-fk-sticky-meta] b') ? $('[data-fk-sticky-meta] b').outerHTML : '';
  function chosen() { var r = $('input[name="fk-size"]:checked', form); return r && r.getAttribute('data-size'); }
  function setLabel(t) { FK.type(label, t); if (stickyLabel) FK.type(stickyLabel, t === 'Select size' ? 'Choose size' : t); }
  function syncMeta() {
    var s = chosen(), meta = $('[data-fk-sticky-meta]');
    if (meta) meta.innerHTML = priceHTML + (one ? '' : ' · ' + (s ? 'Size ' + esc(s) + (isOut() ? ' sold out' : '') : 'Select a size'));
    $$('[data-fk-sticky-sizes] button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-size') === s)); });
  }
  form.addEventListener('change', function (e) {
    if (e.target === variantField) return;
    syncVariant();
    var s = chosen();
    $$('[data-fk-size-table] tr[data-size]', root).forEach(function (r) { r.classList.toggle('is-mine', !!s && r.getAttribute('data-size') === s.toUpperCase()); });   // option values are "m" on some products
    syncMeta();
    var out = isOut();
    atc.hidden = out;
    if (remind) remind.hidden = !out;
    if (shoppay) shoppay.classList.toggle('is-on', !out);
    if (out) { if (stickyLabel) FK.type(stickyLabel, 'Remind me'); return; }
    if (busy) return; setLabel('Add to cart');
  });
  syncMeta();
  syncVariant();
  window.addEventListener('pageshow', syncVariant);   // back/forward can restore the ticked size without a change event
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    var size = chosen();
    if (size && isOut()) { if (remind) remind.click(); return; }
    if (!size) {
      sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sizes.classList.remove('is-nudge'); void sizes.offsetWidth; sizes.classList.add('is-nudge');
      return;
    }
    busy = true; setLabel('Adding...');
    FK.cart.add(handle, size)
      .then(function () { setLabel('Add to cart'); }, function () { setLabel('Try again'); })
      .then(function () { busy = false; });
  });

  /* ---- sticky bar (Public Escape): up while the main button is off screen, down once the footer arrives.
     No size yet: the button opens a size row inside the bar; picking one sets the real size (one source of truth). ---- */
  var sticky = $('[data-fk-sticky]'), atcGone = false, footIn = false;
  if (sticky) {
    var syncSticky = function () { var on = atcGone && !footIn; sticky.toggleAttribute('data-show', on); if (!on) sticky.removeAttribute('data-picking'); };
    // watch the buy box, not the button: the button swaps with "Remind me" when a sold-out size is picked
    new IntersectionObserver(function (es) { atcGone = !es[0].isIntersecting; syncSticky(); }).observe($('.fk-buy', root));
    // the footer is pinned (revealed from under main), so it always "intersects"; watch the end of main instead
    var stop = document.createElement('div'); stop.setAttribute('aria-hidden', 'true'); $('main').appendChild(stop);
    new IntersectionObserver(function (es) { footIn = es[0].isIntersecting; syncSticky(); }, { rootMargin: '0px 0px -60% 0px' }).observe(stop);
    $('[data-fk-sticky-btn]').addEventListener('click', function () {
      if (!chosen()) { sticky.toggleAttribute('data-picking'); return; }
      if (isOut()) { if (remind) remind.click(); return; }
      form.requestSubmit();
    });
    $('[data-fk-sticky-sizes]').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-size]'); if (!b || b.disabled) return;
      var r = $$('input[name="fk-size"]', form).filter(function (x) { return x.getAttribute('data-size') === b.getAttribute('data-size'); })[0];
      if (!r) return;
      r.checked = true; form.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () { sticky.removeAttribute('data-picking'); }, 180);
    });
  }
});
